import { Navigate, RouteObject } from 'react-router-dom';

import NotFound from '../../../components/common/NotFound';
import Settings from '../../settings';
import { SettingsRoutes } from '../../settings/routes';
import { lazyImport } from '../../../utils/lazyImport';
import { GetCareRoutes } from '../../get-care/routes';
import { MessagesRoutes } from '../../messages/routes';
import { RESOURCE_CENTER_URL } from '../../../config';

const GetCare = lazyImport(() => import('../../get-care'), 'default').default;
const Messages = lazyImport(() => import('../../messages'), 'default').default;
const Meeting = lazyImport(
  () => import('../../waiting-room/components/meeting'),
  'default',
).default;
// move to lazyImport for preventing circular dependency issues with unit tests
const PastVisits = lazyImport(
  () => import('../../past-visits/components/PastVisits'),
  'default',
).default;
const HomePage = lazyImport(() => import('../../home/components/Home'), 'default').default;

export const APP_LAYOUT_ROUTES = {
  HOME: { path: 'home', title: 'Home' },
  PAST_VISITS: { path: 'past-visits', title: 'Past Visits' },
  MESSAGES: { path: 'messages', title: 'Messages' },
  RESOURCE_CENTER: {
    path: RESOURCE_CENTER_URL,
    title: 'Resource Center',
  },
  SETTINGS: { path: 'settings', title: 'Settings' },
  GET_CARE: { path: 'get-care', title: 'Get Care' },
  MY_ACCOUNT: { path: 'my-account', title: 'My Account' },
};

export const DEFAULT_APP_LAYOUT_ROUTE = APP_LAYOUT_ROUTES.HOME.path;

export const AppRoutes: RouteObject[] = [
  { path: '*', element: <NotFound /> },
  { index: true, element: <Navigate to={DEFAULT_APP_LAYOUT_ROUTE} replace /> },
  {
    path: APP_LAYOUT_ROUTES.GET_CARE.path,
    element: <GetCare />,
    children: GetCareRoutes,
  },
  { path: APP_LAYOUT_ROUTES.HOME.path, element: <HomePage /> },
  { path: APP_LAYOUT_ROUTES.SETTINGS.path, element: <Settings />, children: SettingsRoutes },
  { path: APP_LAYOUT_ROUTES.MESSAGES.path, element: <Messages />, children: MessagesRoutes },
  { path: APP_LAYOUT_ROUTES.PAST_VISITS.path, element: <PastVisits /> },
  { path: 'meeting/:meetingNumber/:visitId', element: <Meeting /> },
];
